import { render } from "./AccessEmployeeSearchScreen.vue?vue&type=template&id=f42260c0"
import script from "./AccessEmployeeSearchScreen.vue?vue&type=script&lang=js"
export * from "./AccessEmployeeSearchScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__